// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/Button.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/Button.tsx");
  import.meta.hot.lastModified = "1767944325090.4373";
}
// REMIX HMR END

import clsx from 'clsx';
export function Button(props) {
  return <button {...props} className={clsx('hover:text-white hover:bg-primary-600 focus:outline-none focus:z-10 focus:ring-2 focus:ring-offset-0 focus:ring-gray-800', 'bg-gray-100 border rounded-md py-2 px-4 text-base font-medium text-black', 'flex items-center justify-around gap-2', 'disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400', props.className)}>
      {props.children}
    </button>;
}
_c = Button;
var _c;
$RefreshReg$(_c, "Button");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;